// extracted by mini-css-extract-plugin
export default {"legal":"FooterLegal-legal-3TK","details":"FooterLegal-details-3G-","copyright":"FooterLegal-copyright-1Ta","social":"FooterLegal-social-3o1","cards":"FooterLegal-cards-3EY"};